'use client';
import { useState } from 'react';
import IconCheckbox from '../comps/IconCheckbox';
import FormErrorTips from '../comps/FormErrorTips';

export default function FormAgreement({ id, data, index, callback }: any) {
    const [isActive, setIsActive] = useState(!!data.itemVal);
    const toggleHandle = () => {
        setIsActive((active) => {
            callback && callback({ ...data, itemVal: !active }, index, !active);
            return !active;
        });
    };
    return (
        <div className={`form-common-content`}>
            <div className="form-common-agreement" onClick={toggleHandle}>
                <span className={`form-common-agreement-l ${isActive ? 'active' : ''}`}>
                    <IconCheckbox />
                </span>
                <div className="form-common-agreement-r">
                    <div className="form-common-agreement-title">{data.title}</div>
                    <div className="form-common-agreement-desc">{data.desc}</div>
                </div>
            </div>
            <FormErrorTips data={data} />
        </div>
    );
}
